module.exports = __webpack_public_path__ + "static/media/piggy_world.21d45173.png";